//link the information extracted from pdic.action (or other location) to the analytics pages

const pageMetaDataUtils = require('../pageMetaDataUtils');

const PAGE_MAPPING = pageMetaDataUtils.getPageMappingFromMetaDataElement('data-analytics-page-type-mapping');

//specifies the pages where the event for addToCart needs further information
const CART_MAPPING = {
    "category": "category",
    "wishlist": "wishlist view",
    "product": "product detail page"
};

//specifies the pages where the event for add/remove from wishlist needs further information
const WISHLIST_MAPPING = {
    "category": "catalog",
    "wishlist": "wishlist page",
    "product": "product detail page"
};

//specifies in which pages products impression are tracked (the pages that can contain products)
const PRODUCT_IMPRESSION_MAPPING = {
    "account": false,
    "billing": false,
    "brands": false,
    "cart": true,
    "category": true,
    "checkoutlogin": false,
    "content": false,
    "home": true,
    "ordeConfirmation": false,
    "product": true,
    "shipping": false,
    "wishlist": true,
    "storelocator": false
};

module.exports = {
    PAGE_MAPPING: PAGE_MAPPING,
    CART_MAPPING: CART_MAPPING,
    WISHLIST_MAPPING: WISHLIST_MAPPING,
    PRODUCT_IMPRESSION_MAPPING: PRODUCT_IMPRESSION_MAPPING
};



// WEBPACK FOOTER //
// ./cartridges/app_bata_sfra/cartridge/client/default/js/analytics/analytics-mapping.js